import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Box,
  Paper,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  FormControl,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  InputAdornment,
} from "@material-ui/core";
import useStyles from "../../../themes/style.js";
import { IoChevronDownSharp } from "react-icons/io5";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import excel_icon from "../../../images/svg/excel-icon.svg";
import * as XLSX from "xlsx";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import "../../../css/view-resume.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AiTwotoneEdit } from "react-icons/ai";
import { Alert, AlertTitle } from "@mui/material";

const allFields = [
  {
    name: "casual",
    label: "Casual Leave",
    placeholder: "Enter Days",
  },
  { name: "sick", label: "Sick Leave", placeholder: "Enter Days" },
  {
    name: "personal",
    label: "Privilege leave",
    placeholder: "Enter Days",
  },
  {
    name: "permission",
    label: "Permissions",
    placeholder: "Enter Days",
  },
];

const UploadQuickLeaveBalance = () => {
  const classes = useStyles();
  const calendarRef = useRef(null);

  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const [leaveBalanceData, setLeaveBalanceData] = useState([]);
  const [allUserName, setAllUserName] = useState([]);

  const [payslipGenerateDate, setPayslipGenerateDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [payslipUploadModal, setPayslipUploadModal] = useState(false);
  const [editPayslipFields, setEditPayslipFields] = useState({});
  const [leaveBalanceUploadModal, setLeaveBalanceUploadModal] = useState(false);

  const validationSchema = Yup.object({
    ...allFields.reduce((schema, field) => {
      schema[field.name] = Yup.number()
        .min(0, `${field.label} cannot be negative`)
        .transform((_, val) => (val !== "" ? Number(val) : null))
        .typeError("value must be a number")
        .required("Loss of Pay is required")
        .default(0);
      return schema;
    }, {}),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setPayslipGenerateDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    }

    if (calendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarOpen]);

  const transformPayslipData = (data) => {
    return data.map((item) => {
      const emailData = allUserName.find((user) => user.email === item.Email);
      return {
        userId: emailData?.id || null,
        name: item.Name,
        email: item.Email,
        casual: item["CL"],
        sick: item["SL"],
        personal: item["PL"],
        permission: item["No of Permission"],
      };
    });
  };

  const uploadAndConvertXlsx = async (event) => {
    try {
      const target = event.target;
      const file = target.files[0];
      setLoader(true);

      if (!file.name.endsWith(".xlsx")) {
        setLoader(false);
        handleNotificationCall(
          "error",
          "Invalid file format. Please select an XLSX file",
        );
        return;
      }

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const records = XLSX.utils.sheet_to_json(sheet);
          const newRecords = transformPayslipData(records);
          setLeaveBalanceData(newRecords);
        };

        reader.readAsBinaryString(file);
        console.log("Records:", reader.readAsBinaryString(file));
      } else {
        handleNotificationCall("error", "Only choose xlsx format");
        setLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllUserList();
  }, []);

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setAllUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const handleSendBulkLeaveBalance = async () => {
    try {
      setLoader(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}leave/addBulkLeaveBalance`,
        {
          balanceData: leaveBalanceData,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setLeaveBalanceUploadModal(false);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const HeaderElements = () => (
    <Box display="flex" alignItems="baseline" gridGap={4}>
      {leaveBalanceData.length > 0 && (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={()=>setLeaveBalanceUploadModal(true)}
          >
            Update Leave Balance
          </Button>
          <Button
            variant="outlined"
            size="small"
            color="primary"
            className="example-custom-input"
            endIcon={<IoChevronDownSharp />}
            onClick={handlePayslipCalendarOpen}
          >
            {moment(payslipGenerateDate).format("MMM-yyyy")}
          </Button>
          {calendarOpen && (
            <Box
              position="relative"
              zIndex={111}
              className="payslip-month-picker-container"
            >
              <DatePicker
                selected={payslipGenerateDate}
                onChange={handlePayslipMonthChange}
                renderMonthContent={renderMonthContent}
                showMonthYearPicker
                dateFormat="MM/yyyy"
                wrapperClassName="payslip-month-calender"
                popperClassName="payslip-month-calender-popper"
                inline
              />
            </Box>
          )}
        </>
      )}
      <Typography>Total : {leaveBalanceData.length}</Typography>
    </Box>
  );

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  const handleEditItem = (data) => {
    setPayslipUploadModal(true);
    setEditPayslipFields(data);
    console.log("Key:", Object.keys(data), Object.values(data));
    Object.entries(data).forEach(([key, value]) => {
      setValue(key, typeof value === "number" ? Math.round(value) : value);
    });
  };

  const handleCloseEditModal = () => {
    setPayslipUploadModal(false);
    reset();
  };

  const handleEdit = (values) => {
    const updatedData = leaveBalanceData.filter(
      (item) => item.userId !== values.userId,
    );
    setLeaveBalanceData([...updatedData, values]);
    handleCloseEditModal();
    handleNotificationCall("Edited Successfull");
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box>
            <Paper
              variant="outlined"
              style={{
                padding: "20px",
                width: "100%",
                border: "2px dashed #1976d2",
                marginRight: "10px",
              }}
            >
              <Box textAlign="center">
                <img
                  src={excel_icon}
                  style={{ width: "50px", height: "50px" }}
                  width="100%"
                  alt="excel-icon"
                />
                <Typography
                  variant="body2"
                  style={{
                    fontStyle: "italic",
                    color: "#758694",
                    margin: "5px 0px",
                  }}
                >
                  (.XLSX Formats Only)
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  style={{ marginTop: "10px" }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={uploadAndConvertXlsx}
                  />
                </Button>
              </Box>
            </Paper>
          </Box>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <Box className={classes.generatePayslipTable}>
            <MUIDataTable
              title=""
              options={{
                textLabels: {
                  body: {
                    noMatch: "Oops! Matching record could not be found",
                  },
                },
                pagination: false,
                sort: false,
                selectableRows: "none",
                search: false,
                filter: false,
                download: false,
                print: false,
                fixedSelectColumn: true,
                customToolbar: () => (
                  <>
                    <HeaderElements />
                  </>
                ),
                responsive: mobileQuery === true ? "vertical" : "standard",
              }}
              columns={[
                {
                  name: "S.No",
                },
                {
                  name: "Name",
                },
                {
                  name: "Edit",
                },
                {
                  name: "Email",
                },
                {
                  name: "CL",
                },
                {
                  name: "SL",
                },
                {
                  name: "PL",
                },
                {
                  name: "No of Permission",
                },
              ]}
              data={leaveBalanceData.map((item, index) => {
                return [
                  <>{index + 1}</>,
                  <Box
                    sx={{
                      color: "inherit",
                      position: "relative",
                    }}
                  >
                    {item.name}
                  </Box>,
                  <>
                    <AiTwotoneEdit
                      size={20}
                      color="064be2"
                      onClick={() => handleEditItem(item)}
                    />
                  </>,
                  item.email,
                  item.casual,
                  item.sick,
                  item.personal,
                  item.permission,
                ];
              })}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        open={leaveBalanceUploadModal}
        fullWidth
        maxWidth="xs"
        onClose={() => {
            
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{`Update Leave Balance `}</DialogTitle>
        <DialogContent>
          <Box>
            <Alert icon={false} severity="warning">
              <AlertTitle>Note:</AlertTitle>
              <Box component="ul" style={{ listStyle: "disc" }}>
                <Typography component="li">
                  Once the leave balance is sent, you will not be able to make
                  any further changes to the leave balance details.
                </Typography>
                <Typography component="li">
                  Please review the leave balance carefully before generating.
                </Typography>
              </Box>
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            onClick={() => {
              setLeaveBalanceUploadModal(false);
            }}
            variant="contained"
            color="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSendBulkLeaveBalance}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={payslipUploadModal}
        fullWidth
        maxWidth="sm"
        onClose={handleCloseEditModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{"Upload"}</DialogTitle>
        <form onSubmit={handleSubmit(handleEdit)}>
          <DialogContent>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="h6">
                    Name : {editPayslipFields.name}{" "}
                  </Typography>
                  <Typography variant="h6">
                    Email: {editPayslipFields.email}{" "}
                  </Typography>
                </Grid>
                {allFields.map((field) => (
                  <Grid item xs={12} sm={6} md={6} lg={6} key={field.name}>
                    <InputLabel shrink htmlFor={field.name}>
                      {field.label}
                    </InputLabel>

                    <FormControl fullWidth>
                      <TextField
                        size="small"
                        type="number"
                        InputProps={{
                          disableUnderline: true,
                          endAdornment: (
                            <InputAdornment
                              style={{ marginRight: "6px" }}
                              position="end"
                            >
                              Days
                            </InputAdornment>
                          ),
                        }}
                        classes={{ root: classes.customTextField }}
                        inputProps={{ min: 0 }}
                        inputMode="numeric"
                        placeholder={field.placeholder}
                        {...register(field.name)}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </FormControl>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleCloseEditModal}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default UploadQuickLeaveBalance;
